import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { puzzleIds, puzzlePaths, puzzleColors, unlockedPuzzleIds } from './puzzleArtwork.mjs';

export default function PuzzleWordmark({ placedIndexes = [], schoolName = '' }) {
  const unlocked = unlockedPuzzleIds(placedIndexes);
  return <Box component="figure" sx={{ m: 0, my: 2.5 }}>
    <Box component="svg" viewBox="0 0 447.74 112.08" role="img"
      aria-label={`Puzzle micree${schoolName ? ` — ${schoolName}` : ''}: odblokowano ${unlocked.size} z 10 elementów`}
      sx={{ display: 'block', width: '100%', height: 'auto', overflow: 'visible', my: 2 }}>
      <title>Napis micree — odblokowano {unlocked.size} z 10 elementów</title>
      {puzzlePaths.map(({ piece, d }, index) => <path key={`${piece}-${index}`} d={d}
        fill={unlocked.has(puzzleIds[piece]) ? puzzleColors.unlocked : puzzleColors.locked} />)}
    </Box>
    <Stack component="figcaption" direction="row" useFlexGap flexWrap="wrap" spacing={1.5} justifyContent="center">
      {[[puzzleColors.locked, 'Nieodblokowane'], [puzzleColors.unlocked, 'Odblokowane']].map(([color, label]) => <Stack key={label} direction="row" spacing={.75} alignItems="center"><Box aria-hidden="true" sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: color }} /><Typography variant="caption" color="text.secondary">{label}</Typography></Stack>)}
    </Stack>
  </Box>;
}
